import { render, staticRenderFns } from "./MotivoFotoManage.vue?vue&type=template&id=422280d5&scoped=true"
import script from "./MotivoFotoManage.vue?vue&type=script&lang=js"
export * from "./MotivoFotoManage.vue?vue&type=script&lang=js"
import style0 from "./MotivoFotoManage.vue?vue&type=style&index=0&id=422280d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422280d5",
  null
  
)

export default component.exports